<div class="si-label {{styleClass}}" [class.disabled]="disabled" [class.si-label-wrap-text]="wrapText">
  <label *ngIf="text" for="{{forId}}">{{ text | translate }}</label>
  <ng-container *ngIf="!isDesktop; else desktopTemplate">
    <i *ngIf="tooltipText || forceShowTooltipIcon"
       class="si-label_icon"
       [ngClass]="tooltipIcon"
       pTooltip="{{tooltipText | translate}}"
       tooltipPosition="{{tooltipPosition}}"
       tooltipStyleClass="{{tooltipStyleClass}}"
       tooltipEvent="focus"
       [escape]="tooltipEscape"
       [tabindex]="0"
       (click)="onClickTooltipIcon($event)"
    ></i>
  </ng-container>
  <ng-template #desktopTemplate>
    <i *ngIf="tooltipText || forceShowTooltipIcon"
       class="si-label_icon"
       [ngClass]="tooltipIcon"
       pTooltip="{{tooltipText | translate}}"
       tooltipPosition="{{tooltipPosition}}"
       tooltipStyleClass="{{tooltipStyleClass}}"
       [escape]="tooltipEscape"
       (click)="onClickTooltipIcon($event)"
    ></i>
  </ng-template>
</div>
